export type ColorMode = 'light' | 'dark' | 'system'

export function normalizeColorMode(value: string | null): ColorMode {
    return value === 'light' || value === 'dark' ? value : 'system'
}

export function readColorMode(): ColorMode {
    try {
        return normalizeColorMode(window.localStorage.getItem('colorMode'))
    } catch {
        return 'system'
    }
}

export function applyColorMode(mode: ColorMode, systemDark: boolean): boolean {
    const dark = mode === 'dark' || (mode === 'system' && systemDark)
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
    document.documentElement.style.colorScheme = dark ? 'dark' : 'light'
    return dark
}

// Keep browser globals inside a literal: Nuxt replaces window/document with
// undefined in server-compiled functions, so function.toString() is unsafe.
export const COLOR_MODE_BOOTSTRAP = `(function () {
    var mode = 'system';
    try {
        var saved = window.localStorage.getItem('colorMode');
        if (saved === 'light' || saved === 'dark') mode = saved;
    } catch (error) {}
    var dark = mode === 'dark' || (mode === 'system' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
})();`
